import { render, staticRenderFns } from "./platformOperationDetail.vue?vue&type=template&id=2aaeb564&"
import script from "./platformOperationDetail.vue?vue&type=script&lang=js&"
export * from "./platformOperationDetail.vue?vue&type=script&lang=js&"
import style0 from "./platformOperationDetail.vue?vue&type=style&index=0&id=2aaeb564&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports